import { serverResponse } from 'app'
import { NOTIFICATIONS_STATUS } from 'notifications'
import System from 'system'

import { ajax } from 'rxjs/ajax'
import { map } from 'rxjs/operators'

const epicServerRequest = (method, endPoint, originalAction, body = {}, headers = {}) => {
  if (System.AUTH_HEADERS['x-shared-access'] && method === 'get') {
    headers['x-url'] = endPoint.replace(System.api_url, System.api_base_url)
    // eslint-disable-next-line no-param-reassign
    endPoint = `${System.api_url}/general/consultaDocumento/?${endPoint.replace(System.api_url, '')}`
  }

  const params = [endPoint]
  const requestFunction = ajax[method]

  if (requestFunction) {
    if (method.startsWith('p')) {
      params.push(body)
    }

    const requestHeaders = {
      ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json;charset=utf-8' }),
      ...System.AUTH_HEADERS,
      ...headers,
      'x-shared-access': undefined,
    }
    delete requestHeaders['x-shared-access']

    Object.assign(originalAction, {
      serverRequest: {
        endPoint,
        method,
      },
    })

    const requestObservable = requestHeaders['Content-Type']?.toString().includes('text')
      ? map((response) => ({
          ...response,
          response: serverResponse({ data: [response.response] }),
        }))(
          ajax({
            body,
            headers: requestHeaders,
            method: method.toUpperCase(),
            responseType: 'text',
            url: endPoint,
          }),
        )
      : requestFunction(...params, requestHeaders)

    if (originalAction.notification) {
      System.addNotification({
        ...originalAction.notification,
        dismissAfter: 3500,
        status: NOTIFICATIONS_STATUS.WARNING,
      })
    }

    return requestObservable
  }

  return new Error(`No method found: '${method}'`)
}

export default epicServerRequest
